import { z } from "zod";

import { ProjectsLocationsData } from "../../../../../../models/ProjectData";

export const schema = z.object({
  onboardingStatus: z.enum(["INCOMPLETE", "SCHEDULED", "COMPLETE"]).optional(),
  onboardingScheduledDate: z.date().optional(),
  onboardingCompletedDate: z.date().optional(),
});

export type Schema = z.infer<typeof schema>;

export const generateDefaultValues = (
  projectLocation?: ProjectsLocationsData
): Schema => {
  return {
    onboardingStatus: projectLocation?.onboarding_status || "INCOMPLETE",
    onboardingScheduledDate: projectLocation?.onboarding_scheduled_date
      ? new Date(projectLocation.onboarding_scheduled_date)
      : undefined,
    onboardingCompletedDate: projectLocation?.onboarding_completed_date
      ? new Date(projectLocation.onboarding_completed_date)
      : undefined,
  };
};
